import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DashboardService } from '../Dashboad.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.css']
})
export class AnnouncementsComponent implements OnInit, OnChanges {
  data: any;
  displayedColumns: string[] = ['Top Learners', 'Courses Completed'];

  @Input() isManager:boolean;
  @Input() topLearners : any[];
  @Input() teamTopLearners: any[];
  @Input() isViewTeamDashboard : boolean = false;

  constructor(private service:DashboardService) {
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['topLearners']) {
      // console.log('toplearners changed:', changes['topLearners'].currentValue);
    }
    if (changes['teamTopLearners']) {
      // console.log('teamTopLearners changed:', changes['teamTopLearners'].currentValue);
    }

  }

}
